import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { DomainName, STATUS } from "../../../Constants";



// For Get All Comment Post Of Page 
const getAllCommentsOfPostEndPoint = (args)=>`${DomainName}/page/comments?userAccessToken=${args.userToken}&postId=${args.postId}` ;

export const getAllCommentsOfPostAPI = createAsyncThunk('page/comments' , async (args , thunkAPI) =>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getAllCommentsOfPostEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data.comments;
    }catch(error){
        return rejectWithValue(error);
    }
})


// For Get All Post Of Group (Next)
const getPostsOfGroupNextEndPoint = (args)=> `${DomainName}/group/feed?userAccessToken=${args.userToken}&until=${args.until}&groupId=${args.groupId}&paginToken=${args.hasNext}` ; 

export const getAllPostsOfGroupNextAPI = createAsyncThunk('group/allPostsNext' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getPostsOfGroupNextEndPoint(args) , {
            headers : {
                token :args.token
            }
        })
        console.log(response.data)
        return response.data.data
    }catch(error){
        return rejectWithValue(error)
    }
})

// For Get All Post Of Group
const getPostsOfGroupEndPoint = (args)=> `${DomainName}/group/feed?userAccessToken=${args.userToken}&groupId=${args.groupId}` ; 

export const getAllPostsOfSpecificGroupAPI = createAsyncThunk('group/allPosts' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getPostsOfGroupEndPoint(args) , {
            headers : {
                token :args.token
            }
        })
        return response.data.data
    }catch(error){
        return rejectWithValue(error)
    }
})


const initialState = {
    posts : [] , 
    status : STATUS.IDLE ,
    hasNextPost : "" ,
    untilNextPost : '',

    comments : [] , 
    statusOfComments : STATUS.IDLE
}

const SpecificGroupSlice = createSlice({
    name : "specificGroup" , 
    initialState , 
    reducers : {

    } , 
    extraReducers : (builder)=>{
        builder
        // For Get All Posts of Specific Group
        .addCase(getAllPostsOfSpecificGroupAPI.fulfilled , (state , action)=>{
            state.posts = action.payload.posts ; 
            state.status = STATUS.SUCCESS ;
            state.hasNextPost = action.payload?.nextPageToken ; 
            state.untilNextPost = action.payload?.nextUntil ;
        })
        .addCase(getAllPostsOfSpecificGroupAPI.pending , (state , action)=>{
            state.posts = action.payload ; 
            state.status = STATUS.LOADDING ;
        })
        .addCase(getAllPostsOfSpecificGroupAPI.rejected , (state , action)=>{
            state.posts = action.payload ; 
            state.status = STATUS.ERROR ;
        })

        // For Get The Next Post In Group
                .addCase(getAllPostsOfGroupNextAPI.fulfilled , (state , action)=>{
                    state.posts.push(...action.payload.posts) ;
                    state.status = STATUS.SUCCESS  ;
                    state.hasNextPost = action.payload?.nextPageToken ; 
                    state.untilNextPost = action.payload?.nextUntil ;
                })
                .addCase(getAllPostsOfGroupNextAPI.pending , (state , action)=>{
                    state.status = STATUS.LOADDING  ;
                })

        // For Get Comments Of Post Of Specific Group
        .addCase(getAllCommentsOfPostAPI.fulfilled , (state , action)=>{
            state.comments = action.payload ; 
            state.statusOfComments = STATUS.SUCCESS ; 
        })
        .addCase(getAllCommentsOfPostAPI.pending , (state , action)=>{
            state.statusOfComments = STATUS.LOADDING ;
        })
        .addCase(getAllCommentsOfPostAPI.rejected , (state , action)=>{
            state.statusOfComments = STATUS.ERROR ; 
        })
    }
}) ; 


export default SpecificGroupSlice.reducer ; 


export const getSpecificGroupData = (state) => state.SpecificGroupSlice ; 

export const getHasNext = (state)=> state.SpecificGroupSlice.hasNextPost ; 

export const getUntil = (state) => state.SpecificGroupSlice.untilNextPost

